import { defaultDarkTheme } from './default-dark';
import { defaultLightTheme } from './default-light';

const availableThemes = {
	defaultDarkTheme,
	defaultLightTheme,
};

export default availableThemes;
